import { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { showBetslip } from 'right-sidebar';

const Betslip = () => {
  const location = useLocation();

  useEffect(() => {
    showBetslip();
  }, []);

  return (
    <Redirect to={{
      pathname: '/',
      search: location.search,
    }}
    />
  );
};

export default Betslip;
